var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 86,
    viewBox: "0 0 99 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3156 86C10.1434 86 3.8147e-06 76.4355 3.8147e-06 64.958C3.8147e-06 50.0374 21.5041 12.5444 26.7787 4.51022C29.6189 -0.0807513 44.6311 -3.52399 40.5738 6.42312C37.3279 13.3096 24.3443 44.2987 25.1557 44.2987C36.1107 45.4464 44.6311 54.2458 44.6311 64.958C44.6311 76.4355 34.4877 86 22.3156 86ZM99 64.958C99 76.4355 89.2623 86 77.0902 86C64.918 86 54.7746 76.4355 54.7746 64.958C54.7746 50.0374 76.2787 12.5444 81.5533 4.51022C84.3934 -0.0807513 99.4057 -3.52399 95.3484 6.42312C92.1025 13.3096 79.1189 44.2987 79.9303 44.2987C90.8852 45.4464 99 54.2458 99 64.958Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.ad663266b4a488de0ca57b321d1577a2.svg";
export { ForwardRef as ReactComponent };